// SN
const SN = [
  {
    path: '/sn',
    name: 'snPage',
    meta: { tag: 'SN记录' },
    component: () => import('@/pages/SnPage')
  },
  {
    path: '/sn-import-history',
    name: 'snImportHistoryPage',
    meta: { tag: '工厂出货记录' },
    component: () => import('@/pages/SnImportHistoryPage')
  },
  {
    path: '/sn-import-history/change',
    name: 'SnImportHistoryChangePage',
    meta: { tag: 'SN转单' },
    component: () => import('@/pages/SnImportHistoryChangePage')
  },
  {
    path: '/sn-delete-history',
    name: 'SnDeleteHistory',
    meta: { tag: 'SN删除' },
    component: () => import('@/pages/SnDeleteHistoryPage')
  },
  {
    path: '/sn-delete-data',
    name: 'SnDeleteData',
    meta: { tag: 'SN删除记录' },
    component: () => import('@/pages/SnDeleteDataPage')
  },
  {
    path: '/sn/export-by-code',
    name: 'ExportByCode',
    meta: { tag: '批量导出SN信息' },
    component: () => import('@/pages/tools/SnExportByCode')
  },
  {
    path: '/sn-batch-query-activate',
    name: 'SnBatchQueryActivate',
    meta: { tag: '批量导出SN激活信息' },
    component: () => import('@/pages/tools/SnBatchQueryActivatePage')
  },
  {
    path: '/change-sn',
    name: 'ChangeSn',
    meta: { tag: 'SN维修更新记录' },
    component: () => import('@/pages/ChangeSnPage')
  },
  {
    path: '/sn-fast-import',
    name: 'SnFastImport',
    meta: { tag: 'SN快捷导入' },
    component: () => import('@/pages/SnFastImport')
  },
  {
    path: '/trades-sn',
    name: 'TradesSn',
    meta: { tag: '特殊SN管理' },
    component: () => import('@/pages/TradesSnPage')
  }
]

export default SN
